export const TITLE = `שנדע מה רלוונטי עבורכם, בחרו באחת מהאופציות :)`